<div [id]="'pm-form'+ PolicyHolderIndex + '-' + Index" class="inline-item" [formGroup]="Form">
    <enterprise-text-input  [InputId]="'pm-input-name-'+ PolicyHolderIndex + '-' + Index"
                            [InputName]="'PolicyMemberName-'+ PolicyHolderIndex + '-' + Index"
                            Label="Name"
                            [ErrorMessageOverride]="SetErrorTooltipMessage('PolicyMemberName', 'Name')"
                            formControlName="PolicyMemberName"
                            class="inline-form-input"
                            [MaxLength]="PolicyMemberNameMaxLength"
                            [Appearance]="'outline'">
    </enterprise-text-input>
    <enterprise-date-input  [InputId]="'pm-input-dob-'+ PolicyHolderIndex + '-' + Index"
                            [InputName]="'PolicyMemberDateOfBirth-'+ PolicyHolderIndex + '-' + Index"
                            [id]="'pm-input-dob-'+ PolicyHolderIndex + '-' + Index"
                            Label="Date of Birth"
                            formControlName="PolicyMemberDateOfBirth"
                            class="inline-form-input"
                            [Appearance]="'outline'">
    </enterprise-date-input>
    <enterprise-text-input  [InputId]="'pm-input-identification-'+ PolicyHolderIndex + '-' + Index"
                            [InputName]="'PolicyMemberIdentification-'+ PolicyHolderIndex + '-' + Index"
                            Label="ID"
                            [ErrorMessageOverride]="SetErrorTooltipMessage('PolicyMemberIdentification', 'ID')"
                            formControlName="PolicyMemberIdentification"
                            class="inline-form-input"
                            [MaxLength]="PolicyMemberIdentificationMaxLength"
                            [Appearance]="'outline'">
    </enterprise-text-input>
    <div  [id]="'pm-form-action'+ PolicyHolderIndex + '-' + Index" class="">
        <button  [id]="'pm-form-button-add'+ PolicyHolderIndex + '-' + Index"
            (click)="AddPolicyHolderMember()"
            mat-icon-button
            color="primary"
            type="button"
            *ngIf="ShowAddPolicyMemberButton">
        <mat-icon>add</mat-icon>
        </button>
        <button [id]="'pm-form-button-delete'+ PolicyHolderIndex + '-' + Index"
                (click)="DeletePolicyHolderMember()"
                mat-icon-button
                color="warn"
                type="button"
                *ngIf="ShowDeletePolicyMemberButton">
                <mat-icon>horizontal_rule</mat-icon>
        </button>
    </div>
</div>
